/**
 * SummaryPanel Component (Option 2: Dark Sidebar)
 *
 * A sticky sidebar showing cost and timeline summary.
 *
 * Props:
 * - setupCost: number - total setup cost
 * - monthlyCost: number - monthly recurring cost
 * - timeline: string - estimated timeline (e.g., "2 weeks")
 * - packageName: string - selected package name
 * - includedItems: array - list of included items
 */

import { useForm } from '../../contexts/FormContext'
import './SummaryPanel.css'

function SummaryPanel() {
  const { formData } = useForm()

  const formatCurrency = (amount) => {
    return amount > 0 ? `¥${amount.toLocaleString('ja-JP')}` : '—'
  }

  const getTimelineText = () => {
    const { estimatedWeeks, estimatedDays } = formData.timeline
    if (estimatedWeeks === 0 && estimatedDays === 0) return 'Select an option'

    let text = ''
    if (estimatedWeeks > 0) text += `${estimatedWeeks} week${estimatedWeeks > 1 ? 's' : ''}`
    if (estimatedDays > 0) text += `${text ? ', ' : ''}${estimatedDays} day${estimatedDays > 1 ? 's' : ''}`

    return text || 'Not calculated'
  }

  const getPackageName = () => {
    if (!formData.siteBase) return 'Not selected'
    return formData.siteBase === 'basic' ? 'Basic Corporate' : 'Advanced Ecommerce'
  }

  return (
    <aside className="summary-panel">
      <div className="summary-header">
        <h3 className="summary-title">SUMMARY</h3>
      </div>

      <div className="summary-body">
        <div className="summary-item">
          <div className="summary-label">TOTAL COST</div>
          <div className="summary-value">{formatCurrency(formData.costs.setupTotal)}</div>
        </div>

        <div className="summary-item">
          <div className="summary-label">TIMELINE</div>
          <div className="summary-text">{getTimelineText()}</div>
        </div>

        <div className="summary-item">
          <div className="summary-label">PACKAGE</div>
          <div className="summary-text">{getPackageName()}</div>
        </div>

        {formData.costs.monthlyRecurring > 0 && (
          <div className="summary-item">
            <div className="summary-label">MONTHLY COST</div>
            <div className="summary-text">{formatCurrency(formData.costs.monthlyRecurring)}</div>
          </div>
        )}
      </div>
    </aside>
  )
}

export default SummaryPanel
